// extracted by mini-css-extract-plugin
module.exports = {"label":"RgQkb","color-sample":"_2d2_s","colorSample":"_2d2_s","disabled":"_3Ztvv","input":"rjgR9"};